/**
 * Run a spotlight's phase-2 (entity) flight once its predictive phase-1 (twin) flight settles —
 * but ONLY if that spotlight is still the current one when phase 1 settles.
 *
 * Phase 1's promise swallows `FlightInterrupted` and resolves, so "phase 1 was interrupted" and
 * "phase 1 landed" look the same to the `.then` that queues phase 2. Before "Show whole twin"
 * existed nothing interrupted phase 1 on purpose. Now a reset can: it clears the spotlight and
 * flies to the twin, phase 1 resolves, and an unguarded phase 2 would then fly away again and
 * abort the reset's flight — leaving the camera on equipment nobody has selected any more
 * (ops-clear-selection review, 2026-10-14). `isStillCurrent` is checked at the moment phase 1
 * settles, which is the only moment the answer can be known.
 */
export function chainAfterPredictiveFlight(
  predictive: Promise<unknown>,
  dispatch: () => Promise<unknown>,
  isStillCurrent: () => boolean,
): Promise<unknown> {
  return predictive.then(() => (isStillCurrent() ? dispatch() : undefined));
}
